import { Navigate } from 'react-router-dom';

import {
  SubscriptionsCreatePage,
  SubscriptionsDetailPage,
  SubscriptionsEditPage,
  SubscriptionsListPage,
} from 'apps/investcore/components/subscriptions/pages';
import {
  IapNotificationsDetailPage,
  IapNotificationsListPage,
} from 'apps/investcore/components/iap-notifications/pages';
import { SubscriptionTransactionsListPage } from 'apps/investcore/components/subscription-transactions/pages';
import {
  LegacyBankAccountDetailRedirect,
  UserBankAccountDetailPage,
  UserBankAccountListPage,
} from 'apps/investment/components/bank-accounts/pages';
import {
  InvestmentOrderDetailPage,
  InvestmentOrderEditPage,
  InvestmentOrderListPage,
  InvestmentOrderUpdatePage,
} from 'apps/investment/components/fund-order/pages';
import {
  InvestmentStockAccountDetailPage,
  InvestmentStockAccountEditPage,
  InvestmentStockAccountListPage,
} from 'apps/investment/components/stock-accounts/pages';
import { StockAccountDividendCreatePage, StockAccountDividendDetailPage, StockAccountDividendEditPage, StockAccountDividendListPage } from 'apps/investment/components/stock-account-dividends/pages';
import {
  InvestmentBalanceHistoriesDetailPage,
  StockAccountBalanceHistoryPage,
} from 'apps/investment/components/stock-balance-histories/pages';
import {
  InvestmentStockOrderDetailPage,
  InvestmentStockOrderListPage,
} from 'apps/investment/components/stock-order/pages';
import { InvestmentUserIdentificationDraftReKYCPage } from 'apps/investment/components/UserIdentificationDrafts/config';
import {
  InvestmentUserIdentificationImageCreatePage,
  InvestmentUserIdentificationImageListPage,
} from 'apps/investment/components/UserIdentificationImages/config';
import {
  InvestmentUserIdentificationCreatePage,
  InvestmentUserIdentificationEditPage,
  LegacyUserIdentificationEditRedirect,
} from 'apps/investment/components/UserIdentifications/config';
import { InvestmentUserIdentificationDetailPage } from 'apps/investment/components/Users/identification-detail';
import {
  InvestmentUserProgramOrderCreatePage,
  InvestmentUserProgramOrderDetailPage,
  InvestmentUserProgramOrderEditPage,
  InvestmentUserProgramOrderListPage,
} from 'apps/investment/components/UserProgramOrders/pages';
import {
  UserProgramDetailPage,
  UserProgramListPage,
  UserProgramPortfolioPage,
} from 'apps/investment/components/UserPrograms/pages';
import {
  InvestmentUserCreatePage,
  InvestmentUserDetailPage,
  InvestmentUserEditPage,
  InvestmentUserListPage,
} from 'apps/investment/components/Users/pages';
import {
  UserSurveyHistoryCreatePage,
  UserSurveyHistoryDetailPage,
  UserSurveyHistoryEditPage,
  UserSurveyHistoryListPage,
} from 'apps/investment/components/UserSurveyHistories/pages';
import {
  FundEcontractsDetailPage,
  FundEcontractsEditPage,
  FundEcontractsListPage,
} from '../components/fund-econtracts/pages';
import {
  InvestmentFundAccountDetailPage,
  InvestmentFundAccountEditPage,
  InvestmentFundAccountListPage,
} from '../components/FundAccount/pages';
import {
  UserEkycRecordsDetailPage,
  UserEkycRecordsRedirect,
} from '../components/user-ekyc-records/pages';
import UserTodoPage from '../components/Users/todo';
const investmentRoutes = [
  { path: '/investment/users', element: <InvestmentUserListPage /> },
  { path: '/investment/users/create', element: <InvestmentUserCreatePage /> },
  { path: '/investment/users/:id', element: <InvestmentUserDetailPage /> },
  { path: '/investment/users/:id/edit', element: <InvestmentUserEditPage /> },
  {
    path: '/investment/users/:id/identifications',
    element: <Navigate to="/investment/users" />,
  },
  {
    path: '/investment/users/:userId/identifications/:id',
    element: <InvestmentUserIdentificationDetailPage />,
  },
  {
    path: '/investment/users/:userId/identifications/:id/edit',
    element: <InvestmentUserIdentificationEditPage />,
  },
  {
    path: '/investment/users/:userId/identifications/:accountType/create',
    element: <InvestmentUserIdentificationCreatePage />,
  },
  {
    path: '/investment/users/:userId/identifications/:accountType/:id/edit',
    element: <LegacyUserIdentificationEditRedirect />,
  },
  {
    path: '/investment/users/:userId/identifications/:accountType/:id/re-kyc',
    element: <InvestmentUserIdentificationDraftReKYCPage />,
  },
  {
    path: '/investment/users/:userId/identification-images',
    element: <InvestmentUserIdentificationImageListPage />,
  },

  {
    path: '/investment/users/:userId/identification-images/create',
    element: <InvestmentUserIdentificationImageCreatePage />,
  },

  { path: '/investment/users/todo', element: <UserTodoPage /> },
  { path: '/investment/fund-orders', element: <InvestmentOrderListPage /> },
  {
    path: '/investment/fund-orders/:id',
    element: <InvestmentOrderDetailPage />,
  },
  {
    path: '/investment/fund-orders/:id/edit',
    element: <InvestmentOrderEditPage />,
  },
  {
    path: '/investment/fund-orders/:id/update',
    element: <InvestmentOrderUpdatePage />,
  },

  { path: '/investment/user-programs', element: <UserProgramListPage /> },
  {
    path: '/investment/user-programs/:id',
    element: <UserProgramDetailPage />,
  },
  {
    path: '/investment/user-programs/:id/portfolio',
    element: <UserProgramPortfolioPage />,
  },
  {
    path: '/investment/orders',
    element: <InvestmentUserProgramOrderListPage />,
  },
  {
    path: '/investment/orders/create',
    element: <InvestmentUserProgramOrderCreatePage />,
  },
  {
    path: '/investment/orders/:id/edit',
    element: <InvestmentUserProgramOrderEditPage />,
  },
  {
    path: '/investment/orders/:id',
    element: <InvestmentUserProgramOrderDetailPage />,
  },

  {
    path: '/investment/user-survey-histories',
    element: <UserSurveyHistoryListPage />,
  },
  {
    path: '/investment/user-survey-histories/create',
    element: <UserSurveyHistoryCreatePage />,
  },
  {
    path: '/investment/user-survey-histories/:id',
    element: <UserSurveyHistoryDetailPage />,
  },
  {
    path: '/investment/user-survey-histories/:id/edit',
    element: <UserSurveyHistoryEditPage />,
  },
  {
    path: '/investment/fund-accounts',
    element: <InvestmentFundAccountListPage />,
  },
  {
    path: '/investment/fund-accounts/:id',
    element: <InvestmentFundAccountDetailPage />,
  },
  {
    path: '/investment/fund-accounts/:id/edit',
    element: <InvestmentFundAccountEditPage />,
  },
  {
    path: '/investment/stock-accounts',
    element: <InvestmentStockAccountListPage />,
  },
  {
    path: '/investment/stock-accounts/:id/edit',
    element: <InvestmentStockAccountEditPage />,
  },
  {
    path: '/investment/stock-accounts/:id',
    element: <InvestmentStockAccountDetailPage />,
  },
  {
    path: '/investment/stock-accounts/:id/balance-history',
    element: <StockAccountBalanceHistoryPage />,
  },
  { path: '/investment/stock-accounts/:stock_account_id/dividends', element: <StockAccountDividendListPage /> },
  { path: '/investment/stock-accounts/:stock_account_id/dividends/create', element: <StockAccountDividendCreatePage /> },
  { path: '/investment/stock-accounts/:stock_account_id/dividends/:id/edit', element: <StockAccountDividendEditPage /> },
  { path: '/investment/stock-accounts/:stock_account_id/dividends/:id', element: <StockAccountDividendDetailPage /> },
  {
    path: '/investment/users/:userId/bank-accounts',
    element: <UserBankAccountListPage />,
  },
  {
    path: '/investment/users/:userId/bank-accounts/:id',
    element: <UserBankAccountDetailPage />,
  },
  // Bank accounts are only listed per user now.
  {
    path: '/investment/bank-accounts',
    element: <Navigate to="/investment/users" replace />,
  },
  {
    path: '/investment/bank-accounts/:id',
    element: <LegacyBankAccountDetailRedirect />,
  },
  {
    path: '/investment/stock-orders',
    element: <InvestmentStockOrderListPage />,
  },
  {
    path: '/investment/stock-orders/:id',
    element: <InvestmentStockOrderDetailPage />,
  },
  {
    path: '/investment/fund-econtracts',
    element: <FundEcontractsListPage />,
  },
  {
    path: '/investment/fund-econtracts/:id',
    element: <FundEcontractsDetailPage />,
  },
  {
    path: '/investment/fund-econtracts/:id/edit',
    element: <FundEcontractsEditPage />,
  },
  {
    path: '/investment/stock-balance-histories',
    element: <Navigate to="/investment/stock-accounts" replace />,
  },
  {
    path: '/investment/stock-balance-histories/:id',
    element: <InvestmentBalanceHistoriesDetailPage />,
  },
  {
    path: '/investment/users/:userId/user-ekyc-records',
    element: <UserEkycRecordsRedirect />,
  },
  {
    path: '/investment/users/:userId/user-ekyc-records/:id',
    element: <UserEkycRecordsDetailPage />,
  },

  {
    path: '/investment/subscriptions',
    element: <SubscriptionsListPage />,
  },
  {
    path: '/investment/subscriptions/create',
    element: <SubscriptionsCreatePage />,
  },
  {
    path: '/investment/subscriptions/:id',
    element: <SubscriptionsDetailPage />,
  },
  {
    path: '/investment/subscriptions/:id/edit',
    element: <SubscriptionsEditPage />,
  },
  {
    path: '/investment/subscription-transactions',
    element: <SubscriptionTransactionsListPage />,
  },

  {
    path: '/investment/iap-notifications',
    element: <IapNotificationsListPage />,
  },
  {
    path: '/investment/iap-notifications/:id',
    element: <IapNotificationsDetailPage />,
  },
];

export default investmentRoutes;
